import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { InviteDataType } from '../../../../models/jobInvite/jobInvite.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../../models/https';
import useHttps from '../../../useHttps';
import { useSubscriptionAccess } from '../../../../components/Subscription/SubscriptionAccessProvider';

const useInviteToApply = () => {
  const { requireFeature } = useSubscriptionAccess();
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onInviteError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while sending invite'
    );
  };

  const onInviteSuccess = ({ message }: SuccessHttpResponse<any>) => {
    toast.success(message);
  };

  const inviteToApply = async (jobId: string, body: InviteDataType) => {
    if (!jobId || !body.invitedUserId) return;
    setLoading(true);
    if (!await requireFeature('canUseFindLocum')) { setLoading(false); return; }

    const config: HttpConfig = {
      url: `jobs-service/jobs/${jobId}/invitations`,
      method: 'post',
      data: body,
    };

    request(config, onInviteSuccess, setLoading, onInviteError);
  };

  return { inviteToApply, loading };
};

export default useInviteToApply;
